// import { ChainId } from '@pancakeswap-libs/sdk';
import { ChainId } from '@spookyswap/sdk';
import { Configuration } from './pld-finance/config';
import { BankInfo } from './pld-finance';

const configurations: { [env: string]: Configuration } = {
  production: {
    chainId: ChainId.MAINNET,
    networkName: 'Fantom Opera Mainnet',
    ftmscanUrl: 'https://ftmscan.com',
    defaultProvider: 'https://rpc.ftm.tools/',
    deployments: require('./pld-finance/deployments/deployments.mainnet.json'),
    externalTokens: {
      OMB2: ['0x7a6e4E3CC2ac9924605DCa4bA31d1831c84b44aE', 18],
      WFTM: ['0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83', 18],
      FUSDT: ['0x04068DA6C83AFCFA0e13ba15A6696662335D5B75', 6], // This is actually usdc on mainnet not fusdt
      BOO: ['0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE', 18],
      ZOO: ['0x09e145a1d53c0045f41aeef25d8ff982ae74dd56', 0],
      SHIBA: ['0x9ba3e4f84a34df4e08c112e1a0ff148b81655615', 9],
      TOMB: ['0x6c021Ae822BEa943b2E66552bDe1D2696a53fbB7', 18],
      USDC: ['0x04068da6c83afcfa0e13ba15a6696662335d5b75', 6],
      WETH: ['0x74b23882a30290451A17c44f4F05243b6b58C76d', 18],
      PLD: ['0x6A5E24E62135e391B6dd77A80D38Ee5A40834167', 18],
      'USDT-FTM-LP': ['0x2b4C76d0dc16BE1C31D4C1DC53bF9B45987Fc75c', 18],
      'PLD-FTM-LP': ['0xd19D1056807f65fD2E10b8993d869204e1f07155', 18],
      'pSHARE-FTM-LP': ['0x96723306274c3fFFEE1375b322D361d0085BC768', 18],
      'PLD-2OMB-LP': ['0x1730C33246D71F2eB81692D426909835d9fffC07', 18],
      'PLD-pSHARE-LP': ['0xea8dcfe32437f4b881e66bb6a8b625362d998ae8', 18],
      'PLD-USDC-LP': ['0x8f319F600E786E048B359C9867003DeF928DC195', 18],
      'pSHARE-USDC-LP': ['0x31db20b527c6e90bDc8004617BD852557C50c75B', 18],
      'PLD-TOMB-W-LP': ['0xa77597F1B75Ea285B3Be5a07D9Cc53eF388ceA4F', 18]
    },
    baseLaunchDate: new Date('2022-06-02 13:00:00Z'),
    bondLaunchesAt: new Date('2022-12-03T15:00:00Z'),
    masonryLaunchesAt: new Date('2022-12-11T00:00:00Z'),
    refreshInterval: 10000,
  },
  development: {
    chainId: ChainId.MAINNET,
    networkName: 'Fantom Opera Mainnet',
    ftmscanUrl: 'https://ftmscan.com',
    defaultProvider: 'https://rpc.ftm.tools/',
    deployments: require('./pld-finance/deployments/deployments.mainnet.json'),
    externalTokens: {
      OMB2: ['0x7a6e4E3CC2ac9924605DCa4bA31d1831c84b44aE', 18],
      WFTM: ['0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83', 18],
      FUSDT: ['0x04068DA6C83AFCFA0e13ba15A6696662335D5B75', 6], // This is actually usdc on mainnet not fusdt
      BOO: ['0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE', 18],
      ZOO: ['0x09e145a1d53c0045f41aeef25d8ff982ae74dd56', 0],
      SHIBA: ['0x9ba3e4f84a34df4e08c112e1a0ff148b81655615', 9],
      TOMB: ['0x6c021Ae822BEa943b2E66552bDe1D2696a53fbB7', 18],
      USDC: ['0x04068da6c83afcfa0e13ba15a6696662335d5b75', 6],
      WETH: ['0x74b23882a30290451A17c44f4F05243b6b58C76d', 18],
      PLD: ['0x6A5E24E62135e391B6dd77A80D38Ee5A40834167', 18],
      'USDT-FTM-LP': ['0x2b4C76d0dc16BE1C31D4C1DC53bF9B45987Fc75c', 18],
      'PLD-FTM-LP': ['0xd19D1056807f65fD2E10b8993d869204e1f07155', 18],
      'pSHARE-FTM-LP': ['0x96723306274c3fFFEE1375b322D361d0085BC768', 18],
      'PLD-2OMB-LP': ['0x1730C33246D71F2eB81692D426909835d9fffC07', 18],
      'PLD-pSHARE-LP': ['0xea8dcfe32437f4b881e66bb6a8b625362d998ae8', 18],
      'PLD-USDC-LP': ['0x8f319F600E786E048B359C9867003DeF928DC195', 18],
      'pSHARE-USDC-LP': ['0x31db20b527c6e90bDc8004617BD852557C50c75B', 18],
      'PLD-TOMB-W-LP': ['0xa77597F1B75Ea285B3Be5a07D9Cc53eF388ceA4F', 18]
    },
    baseLaunchDate: new Date('2022-06-02 13:00:00Z'),
    bondLaunchesAt: new Date('2022-12-03T15:00:00Z'),
    masonryLaunchesAt: new Date('2022-12-11T00:00:00Z'),
    refreshInterval: 10000,
  },
};

export const bankDefinitions: { [contractName: string]: BankInfo } = {
  /*
  Explanation:
  name: description of the card
  poolId: the poolId assigned in the contract
  sectionInUI: way to distinguish in which of the 3 pool groups it should be listed
        - 0 = Single asset stake pools
        - 1 = LP asset staking rewarding PLD
        - 2 = LP asset staking rewarding pSHARE
  contract: the contract name which will be loaded from the deployment.environmnet.json
  depositTokenName : the name of the token to be deposited
  earnTokenName: the rewarded token
  finished: will disable the pool on the UI if set to true
  sort: the order of the pool
  */
  PldFtmRewardPool: {
    name: 'Earn PLD by FTM',
    poolId: 0,
    sectionInUI: 0,
    contract: 'PldFtmRewardPool',
    depositTokenName: 'WFTM',
    earnTokenName: 'PLD',
    finished: false,
    sort: 1,
    closedForStaking: true,
  },
  PldBooRewardPool: {
    name: 'Earn PLD by BOO',
    poolId: 1,
    sectionInUI: 0,
    contract: 'PldBooGenesisRewardPool',
    depositTokenName: 'BOO',
    earnTokenName: 'PLD',
    finished: false,
    sort: 2,
    closedForStaking: true,
  },
  PldTombRewardPool: {
    name: 'Earn PLD by TOMB',
    poolId: 2,
    sectionInUI: 0,
    contract: 'PldTombGenesisRewardPool',
    depositTokenName: 'TOMB',
    earnTokenName: 'PLD',
    finished: false,
    sort: 2,
    closedForStaking: true,
  },
  PldUsdcRewardPool: {
    name: 'Earn PLD by USDC',
    poolId: 3,
    sectionInUI: 0,
    contract: 'PldUsdcGenesisRewardPool',
    depositTokenName: 'USDC',
    earnTokenName: 'PLD',
    finished: false,
    sort: 2,
    closedForStaking: true,
  },
  PldEthRewardPool: {
    name: 'Earn PLD by WETH',
    poolId: 4,
    sectionInUI: 0,
    contract: 'PldEthGenesisRewardPool',
    depositTokenName: 'WETH',
    earnTokenName: 'PLD',
    finished: false,
    sort: 2,
    closedForStaking: true,
  },
  PldFtmLPPShareRewardPool: {
    name: 'Earn pSHARE by PLD-FTM LP',
    poolId: 0,
    sectionInUI: 2,
    contract: 'PldFtmLPPShareRewardPool',
    depositTokenName: 'PLD-FTM-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  PldPShareRewardPool: {
    name: 'Earn pSHARE by PLD',
    poolId: 2,
    sectionInUI: 1,
    contract: 'PldPShareRewardPool',
    depositTokenName: 'PLD',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  PshareFtmLPPShareRewardPool: {
    name: 'Earn pSHARE by pSHARE-FTM LP',
    poolId: 1,
    sectionInUI: 2,
    contract: 'PshareFtmLPPShareRewardPool',
    depositTokenName: 'pSHARE-FTM-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 7,
    closedForStaking: false,
  },
  PldPshareLPPShareRewardPool: {
    name: 'Earn pSHARE by PLD-pSHARE LP',
    poolId: 1,
    sectionInUI: 3,
    contract: 'PldPshareLPPShareRewardPool',
    depositTokenName: 'PLD-pSHARE-LP',
    earnTokenName: 'pSHARE',
    finished: true,
    sort: 6,
    closedForStaking: false,
  },
  Pld2ombLPPShareRewardPool: {
    name: 'Earn pSHARE by PLD-2OMB LP',
    poolId: 0,
    sectionInUI: 3,
    contract: 'Pld2ombLPPShareRewardPool',
    depositTokenName: 'PLD-2OMB-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  PldUsdcLPPShareRewardPool: {
    name: 'Earn pSHARE by PLD-USDC LP',
    poolId: 2,
    sectionInUI: 3,
    contract: 'PldUsdcLPPShareRewardPool',
    depositTokenName: 'PLD-USDC-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  PshareUsdcLPPShareRewardPool: {
    name: 'Earn pSHARE by pSHARE-USDC LP',
    poolId: 3,
    sectionInUI: 3,
    contract: 'PshareUsdcLPPShareRewardPool',
    depositTokenName: 'pSHARE-USDC-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  PldTombWLPPShareRewardPool: {
    name: 'Earn pSHARE by PLD-TOMB-W LP',
    poolId: 0,
    sectionInUI: 3,
    contract: 'PldTombWLPPShareRewardPool',
    depositTokenName: 'PLD-TOMB-W-LP',
    earnTokenName: 'pSHARE',
    finished: false,
    sort: 6,
    closedForStaking: false,
  },
  OldPshareFtmLPPShareRewardPool: {
    name: 'Earn pSHARE by pSHARE-FTM LP',
    poolId: 1,
    sectionInUI: 2,
    contract: 'OldPshareFtmLPPShareRewardPool',
    depositTokenName: 'pSHARE-FTM-LP',
    earnTokenName: 'pSHARE',
    finished: true,
    sort: 7,
    closedForStaking: true,
  },
};

export default configurations[process.env.NODE_ENV || 'development'];
